import type { Suporte } from '../ui/entrada';

/**
 * O contato do suporte, no painel da entrada.
 *
 * Fixo no código por decisão do dono do produto (8 de setembro de 2026): nesse
 * momento não há sessão, então não dá para buscar do servidor, e uma variável
 * de build seria uma peça a mais para esquecer. Valor vazio esconde a linha —
 * o painel nunca mostra exemplo.
 *
 * `whatsapp` é só dígitos com o país, para o link `wa.me`; `whatsappVisivel` é
 * como aparece escrito.
 */
export const SUPORTE: Suporte = {
  // Sem WhatsApp declarado: a linha fica escondida até haver um número.
  whatsapp: '',
  whatsappVisivel: '',
  telefone: '+55 (19) 3167-0742',
  email: 'suporte@cliqcrm.com.br',
  horario: 'Atendimento das 08:00 às 18:00.',
};
